import React from "react";

const AccidentSection = ({ accident = {} }) => {
  const vehicleImages = accident.vehicle_images || [];
  const vehicleVideos = accident.vehicle_videos || [];
  const loadImages = accident.load_images || [];
  const loadDocuments = accident.load_documents || [];

  const hasAttachments =
    vehicleImages.length > 0 ||
    vehicleVideos.length > 0 ||
    loadImages.length > 0 ||
    loadDocuments.length > 0;

  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = new Date(date);

    if (isNaN(parsedDate.getTime())) {
      return date;
    }

    return parsedDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="insurance-card accident-details-card">

      {/* =================================
          HEADER
      ================================= */}
      <div className="section-header-row">
        <div>
          <h3>Accident Details</h3>

          <p className="section-subtitle">
            Accident information and supporting attachments
          </p>
        </div>
      </div>


      {/* =================================
          ACCIDENT INFORMATION
      ================================= */}
      <div className="accident-info-grid">

        {/* Accident Date */}
        <div className="info-item">
          <label>Accident Date</label>

          <span>
            {formatDate(accident.accident_date)}
          </span>
        </div>


        {/* Accident Time */}
        <div className="info-item">
          <label>Accident Time</label>

          <span>
            {accident.accident_time || "-"}
          </span>
        </div>


        {/* Accident Location */}
        <div className="info-item location-item">
          <label>Accident Location</label>

          <span>
            {accident.accident_location || "-"}
          </span>
        </div>


        {/* Vehicle Loaded */}
        <div className="info-item">
          <label>Vehicle Loaded</label>

          <span
            className={
              accident.vehicle_loaded
                ? "loaded-badge yes"
                : "loaded-badge no"
            }
          >
            {accident.vehicle_loaded ? "Yes" : "No"}
          </span>
        </div>


        {/* Load Details */}
        <div className="info-item load-details-item">
          <label>Load Details</label>

          <span>
            {accident.load_details || "-"}
          </span>
        </div>

      </div>


      {/* =================================
          ATTACHMENTS
      ================================= */}
      {hasAttachments && (
        <div className="accident-attachments">

          <div className="attachments-header">
            <div>
              <h4>Accident Attachments</h4>

              <p>
                Photos, videos and documents related to the accident
              </p>
            </div>

            <span className="attachment-count">
              {vehicleImages.length +
                vehicleVideos.length +
                loadImages.length +
                loadDocuments.length}
            </span>
          </div>


          {/* =================================
              VEHICLE IMAGES
          ================================= */}
          {vehicleImages.length > 0 && (
            <div className="accident-media-section">

              <h4>Vehicle Images</h4>

              <div className="accident-media-grid">

                {vehicleImages.map((image, index) => (
                  <a
                    key={
                      image._id ||
                      image.key ||
                      index
                    }
                    href={image.url}
                    target="_blank"
                    rel="noreferrer"
                    className="accident-media-card"
                  >
                    <img
                      src={image.url}
                      alt={`Vehicle accident ${index + 1}`}
                    />

                    <div className="media-overlay">
                      View Image
                    </div>
                  </a>
                ))}

              </div>
            </div>
          )}


          {/* =================================
              VEHICLE VIDEOS
          ================================= */}
          {vehicleVideos.length > 0 && (
            <div className="accident-media-section">

              <h4>Vehicle Videos</h4>

              <div className="accident-media-grid">

                {vehicleVideos.map((video, index) => (
                  <div
                    key={
                      video._id ||
                      video.key ||
                      index
                    }
                    className="accident-media-card video-card"
                  >
                    <video
                      src={video.url}
                      controls
                      preload="metadata"
                    />
                  </div>
                ))}

              </div>
            </div>
          )}


          {/* =================================
              LOAD IMAGES
          ================================= */}
          {loadImages.length > 0 && (
            <div className="accident-media-section">

              <h4>Load Images</h4>

              <div className="accident-media-grid">

                {loadImages.map((image, index) => (
                  <a
                    key={
                      image._id ||
                      image.key ||
                      index
                    }
                    href={image.url}
                    target="_blank"
                    rel="noreferrer"
                    className="accident-media-card"
                  >
                    <img
                      src={image.url}
                      alt={`Load ${index + 1}`}
                    />

                    <div className="media-overlay">
                      View Image
                    </div>
                  </a>
                ))}

              </div>
            </div>
          )}


          {/* =================================
              LOAD DOCUMENTS
          ================================= */}
          {loadDocuments.length > 0 && (
            <div className="accident-media-section">

              <h4>Load Documents</h4>

              <div className="load-document-list">

                {loadDocuments.map((document, index) => (
                  <a
                    key={
                      document._id ||
                      document.key ||
                      index
                    }
                    href={document.url}
                    target="_blank"
                    rel="noreferrer"
                    className="load-document-item"
                  >
                    <span className="document-icon">
                      📄
                    </span>

                    <div className="document-info">

                      <strong>
                        {document.original_name ||
                          `Load Document ${index + 1}`}
                      </strong>

                      {document.mime_type && (
                        <small>
                          {document.mime_type}
                        </small>
                      )}

                    </div>

                    <span className="document-view">
                      View →
                    </span>

                  </a>
                ))}

              </div>
            </div>
          )}

        </div>
      )}


      {/* =================================
          NO ATTACHMENTS
      ================================= */}
      {!hasAttachments && (
        <div className="accident-empty-state">

          <div className="empty-icon">
            📷
          </div>

          <div>
            <strong>No accident attachments</strong>

            <p>
              No images, videos or documents have been uploaded.
            </p>
          </div>

        </div>
      )}

    </div>
  );
};

export default AccidentSection;